import React, { Component } from 'react';
import { Card, CardBody, CardTitle, Button, Row, Col, Input, CardHeader } from 'reactstrap';
import '../assets/css/traffic.css';

// eslint-disable-next-line
function renderIf(condition, trueComponent, falseComponent) {
	if (condition === true) {
		return trueComponent;
	} else {
		return falseComponent;
	}
}

export default class Traffic extends Component {
	constructor(props) {
		super(props);
		this.state = {
			country: '',
			link: '',
			selectedToChange: {},
			list: [],
		};
	}
	getSessionData(params) {
		return window.sessionStorage.getItem(params);
	}

	async getList() {
		let that = this;
		await fetch(`${process.env.REACT_APP_BACKEND_URL}/traffic/get?token=${that.getSessionData('UToken')}`, {
			headers: {
				accept: '*/*',
			},
			method: 'GET',
		})
			.then((response) => response.json())
			.then((data) => that.setState({ list: data }));
	}

	componentDidMount() {
		this.getList();
	}
	handleLink(event) {
		this.setState({ link: event.target.value });
	}
	addtolist() {
		var newlist = this.state.list;
		var istheracountry = newlist.find((countrylink) => countrylink.country === this.state.country);
		if (istheracountry === undefined) {
			newlist.push({
				country: this.state.country,
				link: this.state.link,
			});
			this.setState({ list: newlist }, () => {
				this.fetchUpdate();
			});
		} else {
			istheracountry.link = this.state.link;
			this.setState({ list: newlist }, () => {
				this.fetchUpdate();
			});
		}
	}

	eliminate(item) {
		if (item) {
			var newlist = this.state.list.filter((value) => value !== item);
			this.setState({ list: newlist }, () => {
				this.fetchUpdate();
			});
		}
	}
	async fetchUpdate(params) {
		await fetch(
			`${process.env.REACT_APP_BACKEND_URL}/traffic/update?token=${this.getSessionData('UToken')}&list=${encodeURIComponent(
				JSON.stringify(this.state.list)
			)}`,
			{
				headers: {
					accept: '*/*',
				},
				method: 'GET',
			}
		)
			.then((response) => response.json())
			.then((data) => console.log(data));
	}

	handleCountrySelected(params) {
		this.setState({ country: params });
	}

	editdata(item) {
		this.setState({
			country: item.country,
			link: item.link,
		});
	}

	render() {
		return (
			<div className='content'>
				{renderIf(
					this.getSessionData('typeofuser') === 'admin',
					<>
						<Row>
							<Col lg='6' md='12'>
								<Card>
									<CardBody>
										<CardHeader>
											<CardTitle tag='h2'>Añadir redireccion por pais</CardTitle>
										</CardHeader>
										<br />
										<div style={{ paddingLeft: '1rem' }}>
											<CountrySelect
												country={this.state.country}
												Selected={(value) => {
													this.handleCountrySelected(value);
												}}
											/>
											<Input
												onChange={(e) => this.handleLink(e)}
												type='text'
												style={{ marginBottom: '1rem', marginTop: '1rem' }}
												placeholder="LINK DE LA CPA"
											></Input>

											<Button
												color='info'
												className='animation-on-hover'
												onClick={() => {
													this.addtolist();
												}}
											>
												Guardar
											</Button>
										</div>
									</CardBody>
								</Card>
							</Col>
							<Col lg='6' md='12'>
								<Card>
									<CardBody>
										<CardHeader>
											<CardTitle tag='h2'>Listado de Paises</CardTitle>
										</CardHeader>
										<br />
										{this.state.list.map((data, index) => {
											return (
												<div className='countryrow' key={index}>
													<p>
														<h5 className='text-success ptittle'>{(data.country + ':').toUpperCase()} </h5> {data.link}{' '}
													</p>
													<Button
														color='info'
														className='animation-on-hover buttonaddcontry'
														onClick={() => {
															this.editdata(data);
														}}
													>
														Editar
													</Button>
													<Button
														color='warning'
														className='animation-on-hover buttoneliminatecontry'
														onClick={() => {
															this.eliminate(data);
														}}
													>
														Eliminar
													</Button>
												</div>
											);
										})}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</>
				)}
			</div>
		);
	}
}

function CountrySelect(props) {
	return (
		<Input
			type='select'
			name='country'
			value={props.country}
			onChange={(e) => {
				props.Selected(e.target.value);
			}}
		>
			<option value=''>Pais</option>
			<option value='Anonymous Proxy'>Anonymous Proxy</option>
			<option value='Satellite Provider'>Satellite Provider</option>
			<option value='Other Country'>Other Country</option>
			<option value='Andorra'>Andorra</option>
			<option value='United Arab Emirates'>United Arab Emirates</option>
			<option value='Afghanistan'>Afghanistan</option>
			<option value='Antigua and Barbuda'>Antigua and Barbuda</option>
			<option value='Anguilla'>Anguilla</option>
			<option value='Albania'>Albania</option>
			<option value='Armenia'>Armenia</option>
			<option value='Angola'>Angola</option>
			<option value='Asia/Pacific Region'>Asia/Pacific Region</option>
			<option value='Antarctica'>Antarctica</option>
			<option value='Argentina'>Argentina</option>
			<option value='American Samoa'>American Samoa</option>
			<option value='Austria'>Austria</option>
			<option value='Australia'>Australia</option>
			<option value='Aruba'>Aruba</option>
			<option value='Aland Islands'>Aland Islands</option>
			<option value='Azerbaijan'>Azerbaijan</option>
			<option value='Bosnia and Herzegovina'>Bosnia and Herzegovina</option>
			<option value='Barbados'>Barbados</option>
			<option value='Bangladesh'>Bangladesh</option>
			<option value='Belgium'>Belgium</option>
			<option value='Burkina Faso'>Burkina Faso</option>
			<option value='Bulgaria'>Bulgaria</option>
			<option value='Bahrain'>Bahrain</option>
			<option value='Burundi'>Burundi</option>
			<option value='Benin'>Benin</option>
			<option value='Saint Barthelemy'>Saint Barthelemy</option>
			<option value='Bermuda'>Bermuda</option>
			<option value='Brunei Darussalam'>Brunei Darussalam</option>
			<option value='Bolivia'>Bolivia</option>
			<option value='Brazil'>Brazil</option>
			<option value='Bahamas'>Bahamas</option>
			<option value='Bhutan'>Bhutan</option>
			<option value='Bouvet Island'>Bouvet Island</option>
			<option value='Botswana'>Botswana</option>
			<option value='Belarus'>Belarus</option>
			<option value='Belize'>Belize</option>
			<option value='Canada'>Canada</option>
			<option value='Cocos (Keeling) Islands'>Cocos (Keeling) Islands</option>
			<option value='Central African Republic'>Central African Republic</option>
			<option value='Congo'>Congo</option>
			<option value='Switzerland'>Switzerland</option>
			<option value="Cote d'Ivoire">Cote d'Ivoire</option>
			<option value='Cook Islands'>Cook Islands</option>
			<option value='Chile'>Chile</option>
			<option value='Cameroon'>Cameroon</option>
			<option value='China'>China</option>
			<option value='Colombia'>Colombia</option>
			<option value='Costa Rica'>Costa Rica</option>
			<option value='Cuba'>Cuba</option>
			<option value='Cape Verde'>Cape Verde</option>
			<option value='Curacao'>Curacao</option>
			<option value='Christmas Island'>Christmas Island</option>
			<option value='Cyprus'>Cyprus</option>
			<option value='Czech Republic'>Czech Republic</option>
			<option value='Germany'>Germany</option>
			<option value='Djibouti'>Djibouti</option>
			<option value='Denmark'>Denmark</option>
			<option value='Dominica'>Dominica</option>
			<option value='Dominican Republic'>Dominican Republic</option>
			<option value='Algeria'>Algeria</option>
			<option value='Ecuador'>Ecuador</option>
			<option value='Estonia'>Estonia</option>
			<option value='Egypt'>Egypt</option>
			<option value='Western Sahara'>Western Sahara</option>
			<option value='Eritrea'>Eritrea</option>
			<option value='Spain'>Spain</option>
			<option value='Ethiopia'>Ethiopia</option>
			<option value='Europe'>Europe</option>
			<option value='Finland'>Finland</option>
			<option value='Fiji'>Fiji</option>
			<option value='Falkland Islands (Malvinas)'>Falkland Islands (Malvinas)</option>
			<option value='Faroe Islands'>Faroe Islands</option>
			<option value='France'>France</option>
			<option value='Gabon'>Gabon</option>
			<option value='United Kingdom'>United Kingdom</option>
			<option value='Grenada'>Grenada</option>
			<option value='Georgia'>Georgia</option>
			<option value='French Guiana'>French Guiana</option>
			<option value='Guernsey'>Guernsey</option>
			<option value='Ghana'>Ghana</option>
			<option value='Gibraltar'>Gibraltar</option>
			<option value='Greenland'>Greenland</option>
			<option value='Gambia'>Gambia</option>
			<option value='Guinea'>Guinea</option>
			<option value='Guadeloupe'>Guadeloupe</option>
			<option value='Equatorial Guinea'>Equatorial Guinea</option>
			<option value='Greece'>Greece</option>
			<option value='South Georgia and the South Sandwich Islands'>South Georgia and the South Sandwich Islands</option>
			<option value='Guatemala'>Guatemala</option>
			<option value='Guam'>Guam</option>
			<option value='Guinea-Bissau'>Guinea-Bissau</option>
			<option value='Guyana'>Guyana</option>
			<option value='Hong Kong'>Hong Kong</option>
			<option value='Heard Island and McDonald Islands'>Heard Island and McDonald Islands</option>
			<option value='Honduras'>Honduras</option>
			<option value='Croatia'>Croatia</option>
			<option value='Haiti'>Haiti</option>
			<option value='Hungary'>Hungary</option>
			<option value='Indonesia'>Indonesia</option>
			<option value='Ireland'>Ireland</option>
			<option value='Israel'>Israel</option>
			<option value='Isle of Man'>Isle of Man</option>
			<option value='India'>India</option>
			<option value='British Indian Ocean Territory'>British Indian Ocean Territory</option>
			<option value='Iraq'>Iraq</option>
			<option value='Iceland'>Iceland</option>
			<option value='Italy'>Italy</option>
			<option value='Jersey'>Jersey</option>
			<option value='Jamaica'>Jamaica</option>
			<option value='Jordan'>Jordan</option>
			<option value='Japan'>Japan</option>
			<option value='Kenya'>Kenya</option>
			<option value='Kyrgyzstan'>Kyrgyzstan</option>
			<option value='Cambodia'>Cambodia</option>
			<option value='Kiribati'>Kiribati</option>
			<option value='Comoros'>Comoros</option>
			<option value='Saint Kitts and Nevis'>Saint Kitts and Nevis</option>
			<option value='Kuwait'>Kuwait</option>
			<option value='Cayman Islands'>Cayman Islands</option>
			<option value='Kazakhstan'>Kazakhstan</option>
			<option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
			<option value='Lebanon'>Lebanon</option>
			<option value='Saint Lucia'>Saint Lucia</option>
			<option value='Liechtenstein'>Liechtenstein</option>
			<option value='Sri Lanka'>Sri Lanka</option>
			<option value='Liberia'>Liberia</option>
			<option value='Lesotho'>Lesotho</option>
			<option value='Lithuania'>Lithuania</option>
			<option value='Luxembourg'>Luxembourg</option>
			<option value='Latvia'>Latvia</option>
			<option value='Libyan Arab Jamahiriya'>Libyan Arab Jamahiriya</option>
			<option value='Morocco'>Morocco</option>
			<option value='Monaco'>Monaco</option>
			<option value='Moldova :  Republic of'>Moldova : Republic of</option>
			<option value='Montenegro'>Montenegro</option>
			<option value='Saint Martin'>Saint Martin</option>
			<option value='Madagascar'>Madagascar</option>
			<option value='Marshall Islands'>Marshall Islands</option>
			<option value='Macedonia'>Macedonia</option>
			<option value='Mali'>Mali</option>
			<option value='Myanmar'>Myanmar</option>
			<option value='Mongolia'>Mongolia</option>
			<option value='Macao'>Macao</option>
			<option value='Northern Mariana Islands'>Northern Mariana Islands</option>
			<option value='Martinique'>Martinique</option>
			<option value='Mauritania'>Mauritania</option>
			<option value='Montserrat'>Montserrat</option>
			<option value='Malta'>Malta</option>
			<option value='Mauritius'>Mauritius</option>
			<option value='Maldives'>Maldives</option>
			<option value='Malawi'>Malawi</option>
			<option value='Mexico'>Mexico</option>
			<option value='Malaysia'>Malaysia</option>
			<option value='Mozambique'>Mozambique</option>
			<option value='Namibia'>Namibia</option>
			<option value='New Caledonia'>New Caledonia</option>
			<option value='Niger'>Niger</option>
			<option value='Norfolk Island'>Norfolk Island</option>
			<option value='Nigeria'>Nigeria</option>
			<option value='Nicaragua'>Nicaragua</option>
			<option value='Netherlands'>Netherlands</option>
			<option value='Norway'>Norway</option>
			<option value='Nepal'>Nepal</option>
			<option value='Nauru'>Nauru</option>
			<option value='Niue'>Niue</option>
			<option value='New Zealand'>New Zealand</option>
			<option value='Oman'>Oman</option>
			<option value='Panama'>Panama</option>
			<option value='Peru'>Peru</option>
			<option value='French Polynesia'>French Polynesia</option>
			<option value='Papua New Guinea'>Papua New Guinea</option>
			<option value='Philippines'>Philippines</option>
			<option value='Pakistan'>Pakistan</option>
			<option value='Poland'>Poland</option>
			<option value='Saint Pierre and Miquelon'>Saint Pierre and Miquelon</option>
			<option value='Pitcairn'>Pitcairn</option>
			<option value='Puerto Rico'>Puerto Rico</option>
			<option value='Palestinian Territory'>Palestinian Territory</option>
			<option value='Portugal'>Portugal</option>
			<option value='Palau'>Palau</option>
			<option value='Paraguay'>Paraguay</option>
			<option value='Qatar'>Qatar</option>
			<option value='Reunion'>Reunion</option>
			<option value='Romania'>Romania</option>
			<option value='Serbia'>Serbia</option>
			<option value='Russian Federation'>Russian Federation</option>
			<option value='Rwanda'>Rwanda</option>
			<option value='Saudi Arabia'>Saudi Arabia</option>
			<option value='Solomon Islands'>Solomon Islands</option>
			<option value='Seychelles'>Seychelles</option>
			<option value='Sudan'>Sudan</option>
			<option value='Sweden'>Sweden</option>
			<option value='Singapore'>Singapore</option>
			<option value='Saint Helena'>Saint Helena</option>
			<option value='Slovenia'>Slovenia</option>
			<option value='Svalbard and Jan Mayen'>Svalbard and Jan Mayen</option>
			<option value='Slovakia'>Slovakia</option>
			<option value='Sierra Leone'>Sierra Leone</option>
			<option value='San Marino'>San Marino</option>
			<option value='Senegal'>Senegal</option>
			<option value='Somalia'>Somalia</option>
			<option value='Suriname'>Suriname</option>
			<option value='South Sudan'>South Sudan</option>
			<option value='Sao Tome and Principe'>Sao Tome and Principe</option>
			<option value='El Salvador'>El Salvador</option>
			<option value='Sint Maarten'>Sint Maarten</option>
			<option value='Syrian Arab Republic'>Syrian Arab Republic</option>
			<option value='Swaziland'>Swaziland</option>
			<option value='Turks and Caicos Islands'>Turks and Caicos Islands</option>
			<option value='Chad'>Chad</option>
			<option value='French Southern Territories'>French Southern Territories</option>
			<option value='Togo'>Togo</option>
			<option value='Thailand'>Thailand</option>
			<option value='Tajikistan'>Tajikistan</option>
			<option value='Tokelau'>Tokelau</option>
			<option value='Timor-Leste'>Timor-Leste</option>
			<option value='Turkmenistan'>Turkmenistan</option>
			<option value='Tunisia'>Tunisia</option>
			<option value='Tonga'>Tonga</option>
			<option value='Turkey'>Turkey</option>
			<option value='Trinidad and Tobago'>Trinidad and Tobago</option>
			<option value='Tuvalu'>Tuvalu</option>
			<option value='Taiwan'>Taiwan</option>
			<option value='Tanzania :  United Republic of'>Tanzania : United Republic of</option>
			<option value='Ukraine'>Ukraine</option>
			<option value='Uganda'>Uganda</option>
			<option value='United States Minor Outlying Islands'>United States Minor Outlying Islands</option>
			<option value='United States'>United States</option>
			<option value='Uruguay'>Uruguay</option>
			<option value='Uzbekistan'>Uzbekistan</option>
			<option value='Holy See (Vatican City State)'>Holy See (Vatican City State)</option>
			<option value='Saint Vincent and the Grenadines'>Saint Vincent and the Grenadines</option>
			<option value='Venezuela'>Venezuela</option>
			<option value='Vietnam'>Vietnam</option>
			<option value='Vanuatu'>Vanuatu</option>
			<option value='Wallis and Futuna'>Wallis and Futuna</option>
			<option value='Samoa'>Samoa</option>
			<option value='Yemen'>Yemen</option>
			<option value='Mayotte'>Mayotte</option>
			<option value='South Africa'>South Africa</option>
			<option value='Zambia'>Zambia</option>
			<option value='Zimbabwe'>Zimbabwe</option>
		</Input>
	);
}
